export const ConceptSchemeAfase = {
  // Grupprubriker (visas inte i filter-dropdowns)
  insurance: { preferredLabel: "Försäkring", group: null },
  subject: { preferredLabel: "Ämne", group: null },
  websiteArea: { preferredLabel: "Webbplatsområde", group: null },

  // Försäkring
  occupationalInjury: { preferredLabel: "Arbetsskada", group: "insurance" },
  illness: { preferredLabel: "Sjukdom", group: "insurance" },
  death: { preferredLabel: "Dödsfall", group: "insurance" },
  parentalLeave: { preferredLabel: "Föräldraledighet", group: "insurance" },
  dismissalDueToRedundancy: { preferredLabel: "Uppsägning vid arbetsbrist", group: "insurance" },

  // Ämne
  commutingAccident: { preferredLabel: "Färdolycksfall", group: "subject" },
  occupationalDisease: { preferredLabel: "Arbetssjukdom", group: "subject" },
  report: { preferredLabel: "Anmälan", group: "subject" },
  application: { preferredLabel: "Ansökan", group: "subject" },
  compensation: { preferredLabel: "Ersättning", group: "subject" },
  supplement: { preferredLabel: "Komplettering", group: "subject" },
  annuity: { preferredLabel: "Livränta", group: "subject" },
  insuranceCoverage: { preferredLabel: "När gäller försäkringen?", group: "subject" },
  confirmEmployment: { preferredLabel: "Bekräfta anställning", group: "subject" },
  extendedCoverage: { preferredLabel: "Efterskydd", group: "subject" },
  familyProtection: { preferredLabel: "Familjeskydd", group: "subject" },
  sendDocuments: { preferredLabel: "Skicka dokument", group: "subject" },
  whoIsCovered: { preferredLabel: "Vem omfattas?", group: "subject" },
  complaintsInfo: { preferredLabel: "Om du inte är nöjd", group: "subject" },
  eServicesInfo: { preferredLabel: "Om e-tjänsterna", group: "subject" },
  insuranceInfo: { preferredLabel: "Om försäkringen", group: "subject" },
  rehabilitationSupportInfo: { preferredLabel: "Om rehabiliteringstödet", group: "subject" },
  workEnvironmentTrainingInfo: { preferredLabel: "Om arbetsmiljöutbildning", group: "subject" },
  trainings: { preferredLabel: "Utbildningar", group: "subject" },
  manageAdministrators: { preferredLabel: "Hantera administratörer", group: "subject" },
  survey: { preferredLabel: "Enkät", group: "subject" },

  // Webbplatsområde
  eServicesForEmployers: { preferredLabel: "E-tjänster för arbetsgivare", group: "websiteArea" },
  insurances: { preferredLabel: "Försäkringar", group: "websiteArea" },
  statisticsTool: { preferredLabel: "Statistikverktyg", group: "websiteArea" },
  pensionContribution: { preferredLabel: "Inbetalning till tjänstepension", group: "websiteArea" },
  myPages: { preferredLabel: "Mina sidor", group: "websiteArea" },
  rehabilitationSupport: { preferredLabel: "Rehabiliteringsstöd", group: "websiteArea" },
  workEnvironmentTrainingSupport: {
    preferredLabel: "Stöd för arbetsmiljöutbildning",
    group: "websiteArea",
  },

  // Övrigt (utan grupp – visas inte i filter-dropdowns)
  scar: { preferredLabel: "Ärr", group: null },
  violenceAndRobbery: { preferredLabel: "Hot, våld och rån", group: null },
} as const;

export type ConceptSchemeAfaseId = keyof typeof ConceptSchemeAfase;

export const isConceptSchemeAfaseId = (value: string): value is ConceptSchemeAfaseId =>
  value in ConceptSchemeAfase;

export const getConceptSchemeAfaseLabel = (value: string) =>
  isConceptSchemeAfaseId(value) ? ConceptSchemeAfase[value].preferredLabel : undefined;

export const getConceptIdsByGroup = (group: string): ConceptSchemeAfaseId[] =>
  (Object.keys(ConceptSchemeAfase) as ConceptSchemeAfaseId[]).filter(
    (id) => ConceptSchemeAfase[id].group === group,
  );
